import styled from 'styled-components'

export const AutoFillGuideContainer = styled.div`
  padding: 0 20px;

  & > button {
    width: 100%;
    border-radius: 50px;
    margin: 40px 0;
  }
`

export const GuideContainer = styled.div`
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 60px;
`

export const GuideItem = styled.div`
  display: flex;
  gap: 28px;

  svg {
    flex-shrink: 0;
    width: 88px;
    height: 88px;
  }
`

export const GuideItemContent = styled.div`
  flex: 1;

  p {
    line-height: 24px;
  }
`

export const ImportantDisclaimerContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ImportantText = styled.div`
  display: flex;
  flex-wrap: wrap;

  span {
    font-weight: normal;
    font-size: 15px;
  }
`

export const CFPLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
`

// Estilos do Onboarding
export const TooltipWrapper = styled.div`
  position: relative;
  right: -105px;

  & > svg {
    position: absolute;
    top: -26px;
    left: -45px;
    transform: scaleX(-1) rotate(-126deg);
  }
`
